export const baseUrl = process.env.REACT_APP_NODE_ENV === 'development' ? `https://www.ablclient.bigmove.dev/api/v1` : 'https://onlinebankingadmin.accessbankliberia.com/api/v1';
export const ablBaseUrl = process.env.REACT_APP_NODE_ENV === 'development' ? 'https://tapi.accessbank.com.lr/API' : 'https://jkapi.accessbank.com.lr/API';
export const proxyUrl = 'https://cors-anywhere.herokuapp.com/'; 

export const apiUrl = (...parts) => {
  const cleanBaseUrl = baseUrl.trim().replace(/\/+$/, '');
  const cleanParts = parts
    .flat()
    .filter(Boolean)
    .map((part) => String(part).trim().replace(/^\/+|\/+$/g, ''));

  return [cleanBaseUrl, ...cleanParts].join('/');
};


 
